const ImageComponent = ({ base64String, height, border, width = '100%' }) => {
  return (
    <img
      style={{ height: `${height}`, width: `${width}`, borderRadius: `${border}` }}
      src={`data:image/jpeg;base64, ${base64String}`}
      alt="Base64 "
    />
  );
};

export default ImageComponent;
